<script>
export default {
    props: {
        index: {
            type: Number,
            required: true
        },
        requiredDocument: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
        qualificationLevels: {
            type: Array,
            required: true
        },
    },

    computed: {
        sourceTable() {
            if (!isNaN(this.documentType)) {
                return 'Qualifications';
            }

            switch (this.documentType) {
                case 'identity': return 'Users';
                case 'driver_license': return 'Users';
                default: return '';
            }
        },
        sourceField() {
            if (!isNaN(this.documentType)) {
                return '';
            }

            switch (this.documentType) {
                case 'identity': return 'id_path';
                case 'driver_license': return 'drivers_licence_path';
                default: return '';
            }
        }
    },

    data() {
        return {
            documentType: this.determineDocumentType(),
            extraQualificationLevels: [
                {"id": "identity", "title": "Identity"},
                {"id": "driver_license", "title": "Drivers License"}
            ]
        }
    },

    methods: {
        determineDocumentType() {
            if (this.requiredDocument.source_table == "Qualifications") {
                return this.requiredDocument.source_id;
            }
            if (this.requiredDocument.source_table == 'Users' && this.requiredDocument.source_field == 'id_path') {
                return 'identity';
            }
            if (this.requiredDocument.source_table == 'Users' && this.requiredDocument.source_field == 'drivers_licence_path') {
                return 'driver_license';
            }
            return null;
        }
    },
    mounted() {
        // append extraQualificationLevels to qualificationLevels
        this.qualificationLevels = this.qualificationLevels.concat(this.extraQualificationLevels);
        // sort qualificationLevels with title ASC
        this.qualificationLevels.sort((a, b) => (a.title > b.title) ? 1 : -1);
    },
}
</script>

<template>
    <div class="grid-x grid-padding-x">
        <input v-if="requiredDocument.id" :name="`required_documents[${index}][id]`" type="hidden" required v-model="requiredDocument.id" />
        <input :name="`required_documents[${index}][source_table]`" type="hidden" required v-model="sourceTable" />
        <input :name="`required_documents[${index}][source_field]`" type="hidden" required v-model="sourceField" />
        <input v-if="!isNaN(this.documentType)" :name="`required_documents[${index}][source_id]`" type="hidden" :value="this.documentType"/>

        <div class="cell small-5">
            <select :disabled="disabled" required v-model="documentType">
                <template v-for="(qualification, index) in qualificationLevels">
                    <option :value="qualification.id">{{ qualification.title }}</option>
                </template>
            </select>
        </div>

        <div class="cell small-6 pl-0">
            <input :disabled="disabled" :name="`required_documents[${index}][title]`" type="text" required v-model="requiredDocument.title" />
        </div>

        <div class="cell shrink small-1">
            <div v-if="!disabled" @click="() => $emit('remove')" class="remove-button"><i class="fas fa-minus-circle"></i></div>
        </div>
    </div>
</template>